/** Tab 栏路由配置 */
export const TAB_ROUTES = [
  { path: '/pages/index/index', label: '主页', icon: 'wap-home-o' },
  { path: '/pages/device-bind/index', label: '设备', icon: 'cluster-o' },
  { path: '/pages/profile/index', label: '个人中心', icon: 'user-o' },
] as const

/** 路由 meta 键名（与 router 定义保持一致） */
export const ROUTE_META = {
  tab: 'tab',
  public: 'public',
  plain: 'plain',
} as const

/** 常用路由路径 */
export const ROUTE_PATHS = {
  home: '/pages/index/index',
  login: '/pages/login/index',
  device: '/pages/device-bind/index',
  profile: '/pages/profile/index',
} as const
